import gql from 'graphql-tag';

export const EXCELLENCE_CLUB_QUERY = gql`
  query IndicadorExcellenceClubQuery(
    $dataInicio: DateTime
    $dataFim: DateTime
    $dealerPk: ID
    $marcaId: ID
    $unidadeNegocioId: ID
  ) {
    indicadorExcellenceClub(
      filter: {
        dataInicio: $dataInicio
        dataFim: $dataFim
        dealerPk: $dealerPk
        marcaId: $marcaId
        unidadeNegocioId: $unidadeNegocioId
      }
    ) {
      qtdFup48
      qtdTD
      qtdVendas
      qtdEmplacados
      idsVendas
      porcentagemTDRealizado
      porcentagemFup48Realizado
      qtdPorcentagemVendasxEmplacados
      qtdPontos
      total
      porcentagem
      qtdIndicadoresIncompletos
    }
  }
`;
